import {
  FETCH_WEEKLY_BLOCK_REQUEST,
  FETCH_WEEKLY_BLOCK_SUCCESS,
  FETCH_WEEKLY_BLOCK_ERROR,
  SAVE_WEEKLY_BLOCK_REQUEST,
  SAVE_WEEKLY_BLOCK_SUCCESS,
  SAVE_WEEKLY_BLOCK_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_WEEKLY_BLOCK_REQUEST:
      return {
        ...state,
        block: {},
        isFetching: true,
        error: null,
      }

    case FETCH_WEEKLY_BLOCK_SUCCESS:
      return {
        ...state,
        block: action.payload,
        isFetching: false,
        error: null,
      }

    case FETCH_WEEKLY_BLOCK_ERROR:
      return {
        ...state,
        block: {},
        isFetching: false,
        error: action.payload,
      }

    case SAVE_WEEKLY_BLOCK_REQUEST:
      return {
        ...state,
        block: {},
        isUpdating: true,
        error: null,
      }

    case SAVE_WEEKLY_BLOCK_SUCCESS:
      return {
        ...state,
        block: action.payload,
        isUpdating: false,
        error: null,
        accordionOpen: true,
      }

    case SAVE_WEEKLY_BLOCK_ERROR:
      return {
        ...state,
        isUpdating: false,
        error: action.payload,
      }

    default:
      return state
  }
}

export default record
